import { Box, Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import {
  DescriptionOutlined,
  InsertDriveFileOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import WidgetCard from "./WidgetCard";
import { timeAgo } from "./utils";

const ACCENT = "#F48206";

export default function ReportsWidget({ reports = [], loading = false }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const list = reports;

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    px: 1,
    py: 0.85,
    borderRadius: 1,
    cursor: "pointer",
    transition: "background-color .15s ease",
    "&:hover": { backgroundColor: alpha(ACCENT, 0.08) },
  };

  return (
    <WidgetCard
      title="EasyReport"
      icon={<DescriptionOutlined fontSize="small" />}
      accent={ACCENT}
      ctaLabel="Ver relatórios"
      onCta={() => navigate("/easyReportV2/relatorios")}
      loading={loading}
      empty={!loading && list.length === 0}
      emptyLabel="Nenhum relatório gerado recentemente."
    >
      {list.map((report) => (
        <Box
          key={report.id}
          sx={rowStyle}
          onClick={() => navigate("/easyReportV2/relatorios")}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: 1.5,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: ACCENT,
              backgroundColor: alpha(ACCENT, 0.12),
              "& svg": { fontSize: 18 },
            }}
          >
            <InsertDriveFileOutlined />
          </Box>
          <Box sx={{ minWidth: 0, flexGrow: 1 }}>
            <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }} noWrap>
              {report.titulo || report.nome || "Relatório"}
            </Typography>
            {report.geradoEm && (
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: theme.palette.text.secondary,
                }}
              >
                Gerado {timeAgo(report.geradoEm)}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </WidgetCard>
  );
}
